import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { imgUrl, formatDate } from "@/lib/api";

export function GalleryCard({ g, tall = false }) {
  return (
    <Link to={`/galleries/${g.slug}`} className="group block img-zoom" data-testid="gallery-card-item">
      <div className={`overflow-hidden bg-[#f4f0ea] ${tall ? "aspect-[4/5]" : "aspect-[4/3]"}`}>
        <img src={imgUrl(g.cover_image)} alt={g.title} className="w-full h-full object-cover" loading="lazy" />
      </div>
      <div className="mt-4 flex items-start justify-between gap-4">
        <div>
          <p className="eyebrow">{g.location}</p>
          <h3 className="mt-1.5 text-2xl text-[#1a261f] group-hover:text-[#1f402b]">{g.title}</h3>
          <p className="mt-1 font-mono-k text-[11px] text-[#5a665e]">{g.images?.length || 0} photographs</p>
        </div>
        <ArrowUpRight size={18} className="mt-6 text-[#c5903b] transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
      </div>
    </Link>
  );
}

export function ArticleCard({ a }) {
  return (
    <Link to={`/articles/${a.slug}`} className="group block img-zoom" data-testid="article-card-item">
      <div className="overflow-hidden aspect-[3/2] bg-[#f4f0ea]">
        <img src={imgUrl(a.cover_image)} alt={a.title} className="w-full h-full object-cover" loading="lazy" />
      </div>
      <p className="mt-5 eyebrow">{a.category} · {formatDate(a.created_at)}</p>
      <h3 className="mt-2 text-xl sm:text-2xl leading-snug text-[#1a261f] group-hover:text-[#1f402b]">{a.title}</h3>
      <p className="mt-3 text-sm text-[#5a665e] leading-relaxed line-clamp-3">{a.excerpt}</p>
    </Link>
  );
}
